export enum TransactionCategory {
    General = 0,
    Maintenance = 1,
    Fixed = 2,
    FeedStock = 3
}
